import { MSG_REQUIRED } from "../../../../../helpers/validator-helper";
import * as Yup from "yup";

export const validationSchema = Yup.object().shape({
  name: Yup.string().required(MSG_REQUIRED),
  description: Yup.string().required(MSG_REQUIRED),
  params: Yup.object().nullable().notRequired(),
  validations: Yup.object().nullable().notRequired(),
});
